<template>
  <div>
    <div><el-input :disabled="disabled" v-model="input"
    :placeholder="placeholder" @blur="handlerBlur"></el-input></div>
  </div>
</template>

<script>
import mixinCommon from './mixins/common'
export default {
  mixins: [mixinCommon],
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.hide {
  height: 0;
}
</style>
